import BookingTable from "./BookingTable";

const BookingsPage = () => {
  return (
    <div className="p-6">
      <BookingTable />
    </div>
  );
};

export default BookingsPage;
